mutation UpdateSsoSettings($input: UpdateSsoSettingsInput!) {
    updateSsoSettings(input: $input) {
        sso {
            isConfigured
            isRequired
        }
    }
}
